// extracted by mini-css-extract-plugin
export var logo = "_cd-2";
export var logoWrapper = "_cd-1";
export var strip = "_cd-0";